import _ from 'underscore';

angular.module('am4').controller('welcomeScreenCtrl', function($element, $scope, $timeout, $translate, errorService, safeLogsService, imageService, $stateParams, authorizationToken, config, orgFacService, ngDialog, equipmentGroupService, $rootScope) {
    var that = this,
        imgService = imageService($stateParams.type),
        orgId;
    that.orgFacType = $stateParams.type;
    that.media = [];
    that.dropIndex = -1;
    that.loading = false;
    that.maxScreens = config.welcomeScreenMaxNumber;
    that.equipmentGroupId = '';
    that.thumbTransformation = 'transformed/w_600,h_337,c_fill,g_auto'; // 1.78:1 aspect ratio to match 15 inch console ratio (1366x768px)
    if ($stateParams.type === 'facilities') {
        that.screenDuration = $scope.fac.data.welcome_screen_duration;
    } else if ($stateParams.type === 'organizations') {
        that.screenDuration = $scope.org.data.welcome_screen_duration;
    }
    that.durationOptions = [
        {
            value: 5,
            display: $translate.instant('N_SECONDS', { n: 5 })
        },
        {
            value: 10,
            display: $translate.instant('N_SECONDS', { n: 10 })
        },
        {
            value: 15,
            display: $translate.instant('N_SECONDS', { n: 15 })
        },
        {
            value: 20,
            display: $translate.instant('N_SECONDS', { n: 20 })
        },
        {
            value: 25,
            display: $translate.instant('N_SECONDS', { n: 25 })
        },
        {
            value: 30,
            display: $translate.instant('N_SECONDS', { n: 30 })
        },
        {
            value: 35,
            display: $translate.instant('N_SECONDS', { n: 35 })
        },
        {
            value: 40,
            display: $translate.instant('N_SECONDS', { n: 40 })
        },
        {
            value: 45,
            display: $translate.instant('N_SECONDS', { n: 45 })
        },
        {
            value: 50,
            display: $translate.instant('N_SECONDS', { n: 50 })
        },
        {
            value: 55,
            display: $translate.instant('N_SECONDS', { n: 55 })
        },
        {
            value: 60,
            display: $translate.instant('ONE_MINUTE', { n: 1 })
        },
        {
            value: 120,
            display: $translate.instant('N_MINUTES', { n: 2 })
        },
        {
            value: 180,
            display: $translate.instant('N_MINUTES', { n: 3 })
        },
        {
            value: 240,
            display: $translate.instant('N_MINUTES', { n: 4 })
        },
        {
            value: 300,
            display: $translate.instant('N_MINUTES', { n: 5 })
        },
        {
            value: 360,
            display: $translate.instant('N_MINUTES', { n: 6 })
        },
        {
            value: 420,
            display: $translate.instant('N_MINUTES', { n: 7 })
        },
        {
            value: 480,
            display: $translate.instant('N_MINUTES', { n: 8 })
        },
        {
            value: 540,
            display: $translate.instant('N_MINUTES', { n: 9 })
        },
        {
            value: 600,
            display: $translate.instant('N_MINUTES', { n: 10 })
        },
        {
            value: 900,
            display: $translate.instant('N_MINUTES', { n: 15 })
        },
        {
            value: 1800,
            display: $translate.instant('N_MINUTES', { n: 30 })
        },
        {
            value: 2700,
            display: $translate.instant('N_MINUTES', { n: 45 })
        },
        {
            value: 3600,
            display: $translate.instant('ONE_HOUR')
        },
        {
            value: 7200,
            display: $translate.instant('N_HOURS', { n: 2 })
        },
        {
            value: 10800,
            display: $translate.instant('N_HOURS', { n: 3 })
        },
        {
            value: 14400,
            display: $translate.instant('N_HOURS', { n: 4 })
        },
        {
            value: 18000,
            display: $translate.instant('N_HOURS', { n: 5 })
        }
    ];

    let getMedia = function() {
        that.loading = true;
        return imgService.getAll($stateParams.id, $stateParams.imageType)
        .then(function(media) {
            that.dropIndex = media.length;

            // Store sized-down image thumbnail url in front-end-only thumbUrl property
            _.each(media, function(file, index) {
                // If file url already contains a 'transformed' in the path, get the part of the path before that
                file.url = file.url.split('transformed/')[0];
                // Ensure last character is a slash before appending thumbTransformation to url
                if (file.url.substr(-1) !== '/') {
                    file.url += '/';
                }
                file.thumbUrl = file.url + that.thumbTransformation;
                file.order = index + 1;
            });

            that.media = media;
            return media;
        })
        .catch(function(e) {
            errorService.addError('GET_WELCOME_SCREENS_ERROR', e);
        })
        .catch(function(e) {
            errorService.addError('GET_WELCOME_SCREENS_ERROR', e);
        })
        .finally(function() {
            that.loading = false;
        });
    };
    getMedia();

    that.getEquipmentGroupMedia = function() {
        that.loading = true;
        imgService.getEquipmentGroupImages($stateParams.id,that.equipmentGroupId,$stateParams.imageType)
        .then(function(media) {
            that.media = _.map(media, function(file, index) {
                const newFile = Object.assign({}, file);
                newFile.url = file.url.split('transformed/')[0];
                if (newFile.url.substr(-1) !== '/') {
                    newFile.url += '/';
                }
                newFile.thumbUrl = newFile.url + that.thumbTransformation;
                newFile.order = index + 1;
                return newFile;
            });
        })
        .catch(function(e) {
            errorService.addError('GET_WELCOME_SCREENS_ERROR', e);
        })
        .finally(function() {
            that.loading = false;
        });
    };

    if ($stateParams.type === 'facilities') {
        orgId = $scope.fac.data.organization_id;
        imageService('organizations').getAll(orgId, $stateParams.imageType).then(function() {
            getMedia(); // OK, go get facility media
            that.orgId = orgId;
        })
        .catch(function(e) {
            getMedia(); // Couldn't confirm existance of org images; might as well fetch facility media
            safeLogsService.log('GET_WELCOME_SCREENS_ERROR', e);
        });
    } else {
        getMedia();
    }

    that.resetDropIndex = function() {
        that.dropIndex = that.media.length;
        that.outsideFileDrag = false;
    };

    that.reorderMedia = function() {
        var formattedMediaData;

        _.each(that.media, function(file, index) {
            file.order = index + 1;
        });

        // Strip out thumbUrl property before saving to server
        formattedMediaData = angular.copy(that.media);
        _.each(formattedMediaData, function(file) {
            delete file.thumbUrl;
            delete file.blob;
        });

        if (that.equipmentGroupId) {
            reorderEquipmentGroupImages(formattedMediaData);
        } else {
            reorderFacilityWideImages(formattedMediaData);
        }
    };

    that.startUpload = function() {
        that.flow.opts.target = that.equipmentGroupId ? imgService.getEquipmentGroupUploadPath($stateParams.id, that.equipmentGroupId, $stateParams.imageType)
            : imgService.getUploadPath($stateParams.id, $stateParams.imageType);
        that.flow.upload();
    };

    that.completeUpload = function($file, $message) {
        var fileReader = new FileReader();
        fileReader.readAsDataURL($file.file);
        fileReader.onload = function(event) {
            var fileMeta = JSON.parse($message),
                // Store index where newly upload image will go
                insertIndex = that.dropIndex >= that.media.length ? that.media.length : that.dropIndex;

            // Set thumbUrl to file blob data uri
            fileMeta.blob = event.target.result;
            fileMeta.thumbUrl = fileMeta.url + that.thumbTransformation;
            fileMeta.order = insertIndex + 1;

            // Remove file from upload queue
            that.flow.files.splice(that.flow.files.indexOf($file), 1);

            // Insert fileMeta and advance the dropIndex
            that.media.splice(insertIndex, 0, fileMeta);
            that.dropIndex += 1;

            // If our upload queue is now empty:
            if (!that.flow.files.length) {
                that.reorderMedia();
            }
        };
    };

    that.validateFile = function($file) {
        that.outsideFileDrag = false;
        if (that.media.length >= that.maxScreens) {
            errorService.addError('MAX_SCREENS_REACHED');
            that.resetDropIndex();
            return false;
        }
        if (!{ png:1,jpg:1,jpeg:1 }[$file.getExtension()]) {
            errorService.addError('IMAGE_FORMAT_ERROR');
            that.resetDropIndex();
            return false;
        }
        if ($file.size > config.welcomeScreenMaxFileSize) {
            errorService.addError('FILE_SIZE_ERROR');
            that.resetDropIndex();
            return false;
        }
        return true;
    };

    that.validateFiles = function($files) {
        that.outsideFileDrag = false;
        if (that.media.length + $files.length > that.maxScreens) {
            var overflowAmt = that.media.length + $files.length - that.maxScreens;
            $files.splice($files.length-overflowAmt, overflowAmt);
            errorService.addError('MAX_SCREENS_REACHED');
        }
        _.filter($files, function($file) {
            if (!{ png:1,jpg:1,jpeg:1 }[$file.getExtension()]) {
                errorService.addError('IMAGE_FORMAT_ERROR');
                return false;
            }
            if ($file.size > config.welcomeScreenMaxFileSize) {
                errorService.addError('FILE_SIZE_ERROR');
                return false;
            }
            return true;
        });

        // If no files are going to proceed to upload
        if (!$files.length) {
            that.resetDropIndex();
        }

        return $files.length;
    };

    that.deleteFile = function(file) {
        let promise;
        file.deleting = true;
        if (that.equipmentGroupId) {
            promise = imgService.deleteEquipmentGroupImage($stateParams.id, that.equipmentGroupId, file.type_name, file.id);
        } else {
            promise = imgService.deleteImage($stateParams.id, file.type_name, file.id);
        }
        promise
        .then(function() {
            that.media = _.reject(that.media, function(item) {
                return item.id === file.id;
            });
            _.each(that.media, function(file, index) {
                file.order = index + 1;
            });
        })
        .catch(function(e) {
            errorService.addError('PHOTO_DELETE_ERROR', e);
        })
        .finally(function() {
            file.deleting = false;
            that.resetDropIndex();
        });
    };

    that.deleteAllFiles = function() {
        var dangerScope = $scope.$new();
        dangerScope.confirmTranslation = 'COMFIRM_REMOVE_ALL_WELCOME_SCREENS';
        dangerScope.confirmButtonTranslation = 'REMOVE_ALL';
        ngDialog.openConfirm({
            template: require('../views/modal/danger.html'),
            plain: true,
            scope: dangerScope,
            className: 'ngdialog-theme-plain--danger'
        })
        .then(function removeConfirmed() {
            _.each(that.media, function(file) {
                that.deleteFile(file);
            });
        });
    };

    that.startDrag = function() {
        that.samePageDrag = true;
        that.outsideFileDrag = false;
        that.resetDropIndex();
    };

    that.endDrag = function() {
        that.samePageDrag = false;
        that.outsideFileDrag = false;
        that.reorderMedia();
    };

    that.getData = function() {
        if (that.equipmentGroupId) {
            equipmentGroupService.getEquipmentGroupByID($stateParams.id, that.equipmentGroupId).then(function(response) {
                if (response[0].welcome_screen_duration !== null) {
                    that.screenDuration = response[0].welcome_screen_duration;
                }
            });

            that.getEquipmentGroupMedia();
        } else {
            orgFacService.getFacility($stateParams.id).then(function(response) {
                that.screenDuration = response.welcome_screen_duration;
            });
            getMedia();
        }

    };

    that.updateDuration = function() {
        if (that.equipmentGroupId) {
            equipmentGroupService.updateEquipmentGroup($stateParams.id, that.equipmentGroupId, {
                welcome_screen_duration : that.screenDuration
            })
            .catch(function(e) {
                errorService.addError('SCREEN_DURATION_UPDATE_ERROR', e);
            });
        } else {
            orgFacService.updateFacility($stateParams.id, { welcome_screen_duration: that.screenDuration })
            .catch(function(e) {
                errorService.addError('SCREEN_DURATION_UPDATE_ERROR', e);
            });
        }
    };

    that.canEditImages = function() {
        if (that.orgFacType === 'facilities') {
            return $rootScope.userPermissions.indexOf('FACILITY_TASKS') > -1;
        } else if (that.orgFacType === 'organizations') {
            return $rootScope.userPermissions.indexOf('ORG_TASKS') > -1 && $rootScope.adminOrganizations && $rootScope.adminOrganizations.includes($scope.org.id);
        }
        return false;
    };

    // Configure ng-sortable drag and drop sorting directive
    that.sortableConfig = {
        disabled: !that.canEditImages(),
        draggable: '.am4-multi-image-edit__sortable-item',
        handle: that.canEditImages() ? '.am4-multi-image-edit__sortable-item__handle' : '',
        animation: 350,
        scroll: true,
        forceFallback: true,
        onStart: that.startDrag,
        onEnd: that.endDrag
    };

    document.addEventListener('dragenter', function() {
        if (!that.samePageDrag) {
            that.outsideFileDrag = true;
        }
    }, false);

    document.addEventListener('dragstart', function() {
        that.samePageDrag = true;
        that.outsideFileDrag = false;
    }, false);

    document.addEventListener('dragend', function() {
        that.samePageDrag = false;
        that.outsideFileDrag = true;
    }, false);

    // Configure ng-flow upload directive
    that.uploadConfig = {
        target: imgService.getUploadPath($stateParams.id, $stateParams.imageType),
        headers: {
            Authorization: authorizationToken.token_type + ' ' + authorizationToken.id_token
        },
        simultaneousUploads: 1
    };

    function reorderFacilityWideImages(formattedMediaData) {
        imgService.reorderImages($stateParams.id, $stateParams.imageType, formattedMediaData)
        .catch(function(e) {
            errorService.addError('WELCOME_SCREENS_CHANGED_ERROR', e);
            getMedia();
        });
    }

    function reorderEquipmentGroupImages(formattedMediaData) {
        imgService.reorderEquipmentGroupImages($stateParams.id, that.equipmentGroupId, $stateParams.imageType, formattedMediaData)
        .catch(function(e) {
            errorService.addError('WELCOME_SCREENS_CHANGED_ERROR', e);
            that.getEquipmentGroupMedia();
        });
    }

    $scope.$on('flow::fileError', function(e) {
        errorService.addError('PHOTO_UPLOAD_ERROR', e);
    });

    $scope.$on('flow::fileRemoved', function() {
        if (!that.flow.files.length) {
            that.resetDropIndex();
        }
    });

    // If file is about to drop into browser window, change the dropindex when dragEnter into existing image
    $scope.$on('indexOnFileDrag', function(event, index) {
        // If we are not dragging something from within the page, and the upload queue is empty, and we aren't at our screens max limit
        if (!that.samePageDrag && !that.flow.files.length && that.media.length < that.maxScreens) {
            if (that.dropIndex <= index) {
                that.dropIndex = index + 1;
            } else {
                that.dropIndex = index;
            }

            $scope.$apply();
        }
    });

    // Save screen duration changes
    $scope.$watch(function() { return that.screenDuration; }, function(newVal, oldVal) {
        if (newVal !== oldVal) {
            if ($stateParams.type === 'organizations') {
                orgFacService.updateOrganization($stateParams.id, { welcome_screen_duration: newVal })
                .catch(function(e) {
                    errorService.addError('SCREEN_DURATION_UPDATE_ERROR', e);
                });
            }
        }
    }, true);
});



// WEBPACK FOOTER //
// ./src/app/controllers/welcomeScreenCtrl.js